/**
 * Renewing a sign-in without stranding the tab (punch list F197, Jeremy
 * 4 Nov 2026), kept here as pure functions so they are tested; the browser
 * wiring is web/src/auth/renewal.ts, useApi.ts, main.tsx and SignInAgainBar.tsx.
 * Fieldpath has the same fix in its own web/src/auth/renewal.ts.
 *
 * THE BRIDGE PAGE. Once a sign-in is 24 hours old MSAL renews through a hidden
 * iframe, and MSAL 5 waits 10 s for the iframe's page to hand the answer to
 * the tab that asked (`broadcastResponseToMainFrame`,
 * `@azure/msal-browser/redirect-bridge`). The iframe was sent to the site
 * root, which loads the whole app and hands nothing over, so every such
 * renewal timed out. Silent renewals now answer at `/auth/redirect.html`
 * (web/auth/redirect.html); ordinary sign-in keeps the root. The path must be
 * registered on the app registration for every address the app is served at.
 *
 * THE ONE-REDIRECT FLAG stops a browser that can never renew silently from
 * bouncing between this app and Entra forever. It is cleared by a silent
 * success AND by a redirect sign-in coming back; until F197 only the first,
 * and a reload keeps sessionStorage, so a tab that had used its one redirect
 * stayed stuck however often it was reloaded.
 */
/** Where Entra sends a silent renewal's answer. */
export const SILENT_REDIRECT_PATH = "/auth/redirect.html";
export function silentRedirectUri(origin) {
    return `${origin}${SILENT_REDIRECT_PATH}`;
}
/** The sessionStorage key: set once before sending someone to Entra to re-authenticate. */
export const REAUTH_FLAG = "scheduler:reauthTried";
/** Forget that this tab has been sent to sign in. No storage: nothing to forget. */
export function clearReauthFlag(store) {
    try {
        store?.removeItem(REAUTH_FLAG);
    }
    catch {
        // The flag is an optimisation, not a rule.
    }
}
/**
 * Record that this tab is being sent to sign in, and say whether it already
 * was. No storage: false, since one redirect is still better than none.
 */
export function claimReauth(store) {
    try {
        const already = store?.getItem(REAUTH_FLAG) === "1";
        store?.setItem(REAUTH_FLAG, "1");
        return already;
    }
    catch {
        return false;
    }
}
/** What a call says once renewal has failed and the one redirect was used. */
export const RENEWAL_FAILED_MESSAGE = "Your sign-in could not be renewed.";
//# sourceMappingURL=signInRenewal.js.map